/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect, useState } from 'react'

const ACADEMY = '/academy'
const JALALI = new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric', month: 'long', day: 'numeric' })

const jalali = (iso) => {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '' : JALALI.format(d)
}

export default function ArticleGrid() {
  const [items, setItems] = useState(null)

  useEffect(() => {
    let alive = true
    fetch('/academy/api/landing-articles')
      .then((r) => r.json())
      .then((j) => alive && setItems(Array.isArray(j?.items) ? j.items : []))
      .catch(() => alive && setItems([]))
    return () => {
      alive = false
    }
  }, [])

  if (!items || !items.length) return null

  return (
    <section className="lp-art" id="seq-articles" dir="rtl">
      <div className="lp-art-head">
        <h2 className="lp-art-title">
          <a href={ACADEMY}>آکادمی سکویا</a>
        </h2>
        <p className="lp-art-sub">آموزش‌های تخصصی و راهنمای استفاده از اپلیکیشن</p>
      </div>
      <div className="lp-art-grid">
        {items.slice(0, 6).map((a) => (
          <a className="lp-art-card" href={a.link} key={a.id}>
            <div className="lp-art-img">
              {a.image ? <img src={a.image} alt="" loading="lazy" decoding="async" draggable="false" /> : <span>سکویا</span>}
            </div>
            <div className="lp-art-body">
              <h3 className="lp-art-name">{a.title}</h3>
              {a.excerpt && <p className="lp-art-ex">{a.excerpt}</p>}
              <p className="lp-art-meta">
                {a.date && <span>{jalali(a.date)}</span>}
                {a.author && <span>{a.author}</span>}
              </p>
            </div>
          </a>
        ))}
      </div>
      <div className="lp-art-all">
        <a className="lp-videos-all-a" href={ACADEMY}>
          <span className="lp-videos-all-s">
            <span className="lp-videos-all-t">مشاهده‌ی همه</span>
          </span>
        </a>
      </div>
    </section>
  )
}
